import React from "react";
import PropTypes from "prop-types";
import "./style.css";

const VaporButton = props => {
  const { children, className, kind, onClick, size, style } = props;

  let additionalClassname = "";
  if (className) {
    additionalClassname += " " + className;
  }
  if (kind) {
    additionalClassname += " " + kind;
  }
  if (size) {
    additionalClassname += " " + size;
  }

  return (
    <button
      className={"ts-vapor-button " + additionalClassname}
      style={style}
      onClick={onClick}
    >
      {children}
    </button>
  );
};

VaporButton.propTypes = {
  children: PropTypes.object,
  onClick: PropTypes.func,
  kind: PropTypes.oneOf(["primary", "secondary", "tertiary"]),
  size: PropTypes.oneOf(["small", "medium", "large"]),
  className: PropTypes.string,
  style: PropTypes.object
};

VaporButton.defaultProps = {
  kind: "primary",
  size: "medium"
};

export default VaporButton;
